import { images } from "../data/siteData";

const points = [
  "Free in-home measure and quote",
  "Custom made curtains and blinds",
  "Wide range of fabrics and styles",
  "Professional, tidy installation",
];

function About() {
  return (
    <section id="about" className="about">
      <div className="container about__inner">
        <div className="about__image">
          <img
            src={images.about}
            alt="The Imagine Designs shopfront, signposted for curtains, blinds, fabrics and tracks"
            loading="lazy"
          />
        </div>
        <div className="about__content">
          <p className="eyebrow">About Us</p>
          <h2>
            Creating beautiful and practical window dressings in Golden Bay since 2009.
          </h2>
          <p>Call in and view our blind display and range of fabrics and have a chat.</p>
          <ul className="about__points">
            {points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default About;
